import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'innovation.dashboard',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'ideas.report.card',
                        },
                      },
                    },
                    span: 3,
                  },
                  {
                    content: {
                      column: {
                        elements: [
                          {
                            content: {
                              row: {
                                elements: [
                                  {
                                    content: {
                                      widget: {
                                        widget: {
                                          alias: 'ideas.status.bar',
                                        },
                                      },
                                    },
                                    span: 4,
                                  },
                                  {
                                    content: {
                                      widget: {
                                        widget: {
                                          alias: 'assets.los.donut',
                                        },
                                      },
                                    },
                                    span: 4,
                                  },
                                ],
                              },
                            },
                            height: 400,
                          },
                          {
                            content: {
                              widget: {
                                widget: {
                                  alias: 'ideas.table',
                                },
                              },
                            },
                            height: 400,
                          },
                        ],
                      },
                    },
                    span: 8,
                  },
                ],
              },
            },
            height: 800,
          },
        ],
      },
    },
    description: 'Explore Innovation Ideas',
    name: 'Innovation Dashboard',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
